
/**
 * Returns the OAuth client ID based on the current environment
 * @returns {string} OAuth client ID for the current environment
 */
export const getOAuthClientId = () => {
  const env = window.MAW && window.MAW.env;

  if (env === 'local' || env === 'qa' || env === 'dev') {
    return 'my-account-web-development';
  }

  if (env === 'staging' || env === 'preprod') {
    return 'my-account-web-preprod';
  }

  return 'my-account-web';
};

/**
 * Returns the OAuth redirect URI for the callback endpoint
 * @returns {string} Formatted OAuth redirect URI
 */
export const getOAuthRedirectUri = () => {
  const callbackUrl = new URL('/oauth/callback', window.location.origin);
  return callbackUrl.toString();
};


/**
 * Encodes the current URL for use as an OAuth state parameter
 * @returns {string} URI-encoded current URL
 */
export const encodeCurrentUrl = () => encodeURIComponent(window.location.href);

export const getOAuthBaseUrl = () => 'https://oauth.xfinity.com';

/**
 * Build OAuth authorization URL for account switching
 */
export const buildOAuthUrl = () => {
  const clientId = getOAuthClientId();
  const redirectUri = getOAuthRedirectUri();
  const baseUrl = getOAuthBaseUrl();
  const params = new URLSearchParams({
    client_id: clientId,
    response_type: 'code',
    redirect_uri: redirectUri,
    state: window.location.href,
    prompt: 'select_billing_account',
  });

  return `${baseUrl}/oauth/authorize?${params.toString()}`;
};
